import { setLinksWithData } from '../dataSetters'

export const mapLinksWithData = (links_with_data) =>
  links_with_data.map((link) => ({
    ...setLinksWithData(link),
  }))
